import axios from 'axios';
import API, { getApiUrl, getApiToken } from '../plugins/axios';

export const buscaLocais = (local, temaId = '') => {
  return new Promise((resolve, reject) => {
    API.get(`google-maps/buscar?endereco=${local}&tema_id=${temaId}`)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const buscaPadarias = () => {
  return new Promise((resolve, reject) => {
    API.get('padarias')
      .then((resp) => {
        resolve(resp.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const padariaSlugCache = new Map();

export const buscaPadariaSlug = (slug) => {
  const cacheKey = `${API.defaults.baseURL || ''}:${slug}`;

  if (padariaSlugCache.has(cacheKey)) {
    return padariaSlugCache.get(cacheKey);
  }

  const promise = API.get(`padarias/${slug}`)
    .then((resp) => resp.data)
    .catch((error) => {
      padariaSlugCache.delete(cacheKey);
      throw error;
    });

  padariaSlugCache.set(cacheKey, promise);
  return promise;
};

export const buscaZonas = () => {
  return new Promise((resolve, reject) => {
    API.get('zonas')
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const buscaBairros = (zonaId) => {
  return new Promise((resolve, reject) => {
    API.get(`zonas/${zonaId}/bairros`)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const votacao = (data, token = '') => {
  return new Promise((resolve, reject) => {
    const config = {};
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`
      };
    }

    API.post('votacao', data, config)
      .then((resp) => {
        localStorage.removeItem('vote_data');
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const votacaoFase2 = (data, token = '') => {
  return new Promise((resolve, reject) => {
    const config = {};
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`
      };
    }

    API.post('votacao/fase2', data, config)
      .then((resp) => {
        localStorage.removeItem('vote_data');
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const verificaEmail = (hash) => {
  return new Promise((resolve, reject) => {
    API.get(`email/verificar/${hash}`)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export function signInSSO(searchString, provider) {
  return new Promise((resolve, reject) => {
    API.get(`auth/login/${provider}/callback${searchString}`)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const descobreCidadePorHash = async (hash) => {
  const ordemCidades = ['belo-horizonte', 'sao-paulo'];

  for (let i = 0; i < ordemCidades.length; i += 1) {
    const cidade = ordemCidades[i];
    const baseURL = getApiUrl(cidade);
    const token = getApiToken(cidade);
    const endpoint = baseURL.endsWith('/')
      ? `${baseURL}hash/verificar/${hash}`
      : `${baseURL}/hash/verificar/${hash}`;

    try {
      // eslint-disable-next-line no-await-in-loop
      const resp = await axios.get(endpoint, {
        headers: {
          Accept: 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        }
      });

      if (
        resp.status === 200 &&
        (resp.data?.success === 'ok' || resp.data?.status === 'ok')
      ) {
        return cidade;
      }
    } catch (err) {
      // Se der hash_not_found ou erro, segue para a próxima cidade
    }
  }

  return null;
};
